// extracted by mini-css-extract-plugin
module.exports = {"RecordsContainer":"QualRecords_RecordsContainer__s_jPP","PlayerInfo":"QualRecords_PlayerInfo__3KAPV","PlayerImage":"QualRecords_PlayerImage__2ye0w"};